// extracted by mini-css-extract-plugin
module.exports = {"landing":"landing_landing__Vy19A","container":"landing_container__1H28t","illustration":"landing_illustration__Q6Lg9"};